import { isUtagLoaded } from '../utils/common-utils';

const BaseAnalyticsEvent = {
  event_name: 'live_chat',
  event_category: 'live_chat_start_module',
  event_action: 'clicked'
} as const;

export const AnalyticsEvents = {
  FloatingButtonClickedOpen: {
    ...BaseAnalyticsEvent,
    event_label: 'Floating Chat Button - Open'
  },

  FloatingButtonClickedClose: {
    ...BaseAnalyticsEvent,
    event_label: 'Floating Chat Button - Close'
  },

  XButtonClicked: {
    ...BaseAnalyticsEvent,
    event_label: 'Drawer X Button'
  },

  BeautyEngagementButtonClicked: {
    ...BaseAnalyticsEvent,
    event_label: 'Drawer Button - Beauty Advice'
  },

  SupportEngagementButtonClicked: {
    ...BaseAnalyticsEvent,
    event_label: 'Drawer Button - Customer Service'
  }
} satisfies Record<string, AnalyticsEvent>;

export function makePageEngagementAnalyticsEvent(key: EngagementKey): AnalyticsEvent {
  return {
    ...BaseAnalyticsEvent,
    event_label: `On Page CTA - key: ${key}`
  };
}

export async function emitAnalyticsEvent(event: AnalyticsEvent): Promise<void> {
  const u = await isUtagLoaded();
  if (!window?.site?.track?.evtLink || !u) {
    console.warn(
      'LiveChat attempted to send an Analytics event, but window.site.track.evtLink() was not available.'
    );
    return;
  }
  window.site.track.evtLink(event);
}
